import ChallengeTypeQRCode from './ChallengeTypeQRCode';

export default ChallengeTypeQRCode;
